import { useWorkspace } from '@/features/workspaces/hooks';
import { useWorkspaceAdmin } from '@/features/workspaces/hooks/useWorkspace';
import { useUpdateCampaignMutation } from '@/services/endpoints/campaigns/endpoints';
import { CampaignResponse } from '@/services/endpoints/campaigns/types';
import { ChangeEvent, FC, useState } from 'react';
import { CampaignDetailName } from './CampaignDetailName';
import { ChangeCampaignNameButton } from './ChangeCampaignNameButton';

type CampaignDetailEditableNameProps = {
  campaign: CampaignResponse;
};

export const CampaignDetailEditableName: FC<CampaignDetailEditableNameProps> = ({ campaign }) => {
  const workspace = useWorkspace();
  const isWorkspaceAdmin = useWorkspaceAdmin();

  const [campaignName, setCampaignName] = useState<string>(campaign.name);
  const [isEditingName, setIsEditingName] = useState<boolean>(false);

  const [updateCampaign, { isLoading: isUpdateLoading }] = useUpdateCampaignMutation();

  const handleCampaignNameChange = (ev: ChangeEvent<HTMLInputElement>) => {
    setCampaignName(ev.target.value);
  };

  const handleCampaignRenameConfirm = async () => {
    if (campaignName === campaign.name) {
      setIsEditingName(false);
      return;
    }

    await updateCampaign({
      campaignId: campaign.id,
      workspaceId: workspace.id,
      name: campaignName,
      description: campaign.description,
    });

    setIsEditingName(false);
  };

  return (
    <>
      <CampaignDetailName campaignName={campaign.name} isEditingName={isEditingName} onCampaignNameChange={handleCampaignNameChange} />
      {isWorkspaceAdmin && (
        <ChangeCampaignNameButton
          isEditingName={isEditingName}
          isLoading={isUpdateLoading}
          onEditClick={() => setIsEditingName(true)}
          onCampaignRenameConfirm={handleCampaignRenameConfirm}
        />
      )}
    </>
  );
};
